module.exports = __webpack_public_path__ + "img/10blue.64c93b9e.png";